import React from 'react';
import type { GridColumnVisibilityModel } from '@mui/x-data-grid-premium';

import { type PaginationProps } from '../../../hooks/usePagination';
import useLocalStorage from '../../../hooks/useLocalStorage';
/* eslint-disable-next-line import/no-cycle */
import useViewState, { type ViewState, type ViewStateType } from './useViewState';

type ViewTableState = ViewState & {
	visibleColumns?: GridColumnVisibilityModel;
};

interface ViewTableStateType {
	paginationProps: ViewStateType['paginationProps'];
	columnVisibilityModel: GridColumnVisibilityModel;
	setColumnVisibilityModel: (newValue: GridColumnVisibilityModel) => void;
}

type ViewTableStateProps = PaginationProps;

export default function useViewTableState(props: ViewTableStateProps) {
	const viewState = useViewState({
		id: props.id,
		module: props.module,
		filter: props.filter,
		order: props.order,
		paginator: props.paginator
	});

	const [viewTableState, setViewTableState] = useLocalStorage<ViewTableState | undefined>(props.id, undefined);

	const handleTableStateChange = React.useCallback(
		(key: string, newValue: any) => {
			setViewTableState(state => {
				const newState = state ? state : {};
				newState[key] = newValue;
				return { ...newState };
			});
		},
		[setViewTableState]
	);

	const [columnVisibilityModel, setColumnVisibilityModel] = React.useState<GridColumnVisibilityModel>(
		viewTableState?.visibleColumns || {}
	);

	return {
		paginationProps: viewState.paginationProps,
		columnVisibilityModel,
		setColumnVisibilityModel: newValue => {
			setColumnVisibilityModel(newValue);
			handleTableStateChange('visibleColumns', newValue);
		}
	} as ViewTableStateType;
}
